export function remoteThumb(url, width = 160) {
  if (!url) return ''
  if (import.meta.dev) return url
  return `/.netlify/images?url=${encodeURIComponent(url)}&w=${width}&fit=cover&q=85&fm=webp`
}

export function remoteThumbSrcset(url, widths = [160, 320]) {
  if (!url || import.meta.dev) return ''
  return widths.map((width) => `${remoteThumb(url, width)} ${width}w`).join(', ')
}
